import React from 'react';
import styled from 'styled-components';
import Radio from '../input/Radio';
import Spacer from '../Spacer';

const OptionContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

const RadioCenterer = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  children: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
};

export function SelectOption({ children, selected, onClick }: Props) {
  return (
    <OptionContainer
      onClick={() => {
        console.log('onclick');
        if (onClick) onClick();
      }}
    >
      <RadioCenterer>
        <Radio selected={selected} />
      </RadioCenterer>
      <Spacer horizontal spacing={3} />
      <div>{children}</div>
    </OptionContainer>
  );
}
